<template>
  <div class="min-h-screen">
    <!-- 顶部导航栏 -->
    <header class="bg-white shadow-sm fixed top-0 left-0 right-0 z-50">
      <div class="px-4 py-3 bg-gradient-to-r from-blue-50 to-blue-100 flex items-center">
        <a @click="$router.back()" class="text-gray-600 hover:text-blue-500 transition-colors">
          <!-- <font-awesome-icon icon="arrow-left" class="text-xl" /> -->
        </a>
        <h1 class="text-lg font-semibold text-center flex-1">设备管理</h1>
      </div>
    </header>

    <!-- 主要内容区域 -->
    <main class="pt-16 px-4 pb-6">
      <!-- 设备列表 -->
      <div class="space-y-4">
        <!-- 设备卡片 -->
        <div 
          v-for="device in devices" 
          :key="device.machineId"
          class="device-card bg-gradient-to-br from-white to-blue-50 rounded-2xl p-4 shadow-sm relative"
          :data-device-id="device.machineId"
          @click="showDeviceDetail(device)"
        >
          <div class="flex items-center justify-between mb-4">
            <div class="flex items-center">
              <div class="w-12 h-12 bg-gradient-to-br rounded-xl flex items-center justify-center" :class="device.machineStatus === 'online' ? 'from-blue-400 to-blue-500' : 'from-purple-400 to-purple-500'">
                 <img v-if="device.petImage" :src="device.petImage" alt="" class="w-12 h-12 rounded-xl">
                 <!-- <font-awesome-icon  icon="microchip" class="text-white text-xl" /> -->
              </div>
              <div class="ml-3">
                <div class="flex items-center gap-2">
                  <h3 class="font-medium text-gray-800">{{ device.petName }}的设备</h3>
                  <!-- 默认设备标识 -->
                  <div class="default-badge inline-flex items-center" :class="{'hidden': device.isDefault == 0}">
                    <div class="bg-blue-50 border border-blue-100 rounded-full px-2 py-0.5 flex items-center gap-1">
                      <!-- <font-awesome-icon icon="crown" class="text-yellow-400 text-xs" /> -->
                      <img style="width: 14px;height: 12px;" class="text-yellow-400 text-xs" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/crown.png"/>
                      <span class="text-blue-600 text-xs font-medium">默认</span>
                    </div>
                  </div>
                </div>
                <p class="text-sm text-gray-500">设备ID: {{ device.deviceName }}</p>
              </div>
            </div>
            <div class="flex items-center">
              <span :class="device.machineStatus === 'online' ? 'text-green-500' : 'text-gray-500'" class="text-sm mr-2 font-medium">
                {{ device.machineStatus === 'online' ? '在线' : '离线' }}
              </span>
              <!-- <font-awesome-icon icon="chevron-right" class="text-blue-400" /> -->
              <img style="width: 16px;height: 17px;" class="text-blue-400" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/chevron-right2.png"/>
            </div>
          </div>
          <div class="grid grid-cols-3 gap-4 text-center text-sm">
            <div class="bg-white/50 rounded-xl p-2">
              <p class="text-gray-500">电量</p>
              <p :class="getBatteryClass(device.machinePower)" class="font-medium">{{ device.machinePower }}%</p>
            </div>
            <div class="bg-white/50 rounded-xl p-2">
              <p class="text-gray-500">信号</p>
              <p :class="device.machineStatus === 'online' ? 'text-blue-500' : 'text-gray-500'" class="font-medium">
                {{ device.machineStatus === 'online' ? '良好' : '--' }}
              </p>
            </div>
            <div class="bg-white/50 rounded-xl p-2">
              <p class="text-gray-500">固件版本</p>
              <p class="font-medium text-gray-700">{{ device.firmwareVersion || 'v2.1.0' }}</p>
            </div>
          </div>
        </div>

        <!-- 添加设备按钮 -->
        <button 
          class="w-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-2xl p-4 flex items-center justify-center space-x-2 transition-all duration-300 shadow-sm hover:shadow-md"
          @click="showAddDeviceModal"
        >
          <!-- <font-awesome-icon icon="plus-circle" class="text-xl" /> -->
          <img style="width: 18px;height: 18px;" class="text-xl" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/plus-circle-fill.png"/>
          <span class="text-lg font-medium">添加新设备</span>
        </button>
      </div>
    </main>

    <!-- 添加设备模态框 -->
    <div id="addDeviceModal" class="fixed inset-0 z-50" :class="{'hidden': !showBindDialog}">
      <div class="modal-backdrop absolute inset-0 bg-black/40" @click="closeAddDeviceModal"></div>
      <div class="modal-content absolute top-1/2 left-1/2 w-11/12 max-w-md bg-white rounded-2xl p-5 shadow-xl transform -translate-x-1/2 -translate-y-1/2 animate-modalFade">
        <div class="flex justify-between items-center mb-4">
          <div class="flex items-center gap-2">
            <div class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
              <!-- <font-awesome-icon icon="plus-circle" class="text-blue-500" /> -->
              <img style="width: 15px;height: 15px;" class="text-blue-500" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/plus-circle-fill2.png"/>
            </div>
            <h3 class="text-lg font-semibold text-gray-800">添加新设备</h3>
          </div>
          <button @click="closeAddDeviceModal" class="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:bg-gray-100 hover:text-gray-600 transition-colors">
            <!-- <font-awesome-icon icon="times" /> -->
            <img style="width: 20px;height: 20px;" class="text-blue-500" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/times.png"/>
          </button>
        </div>

        <form id="addDeviceForm" class="space-y-4" @submit.prevent="bindDevice">
          <!-- 基本信息 -->
          <div class="space-y-3">
            <!-- 宠物名称 -->
            <div class="relative">
              <label for="petName" class="block text-xs font-medium text-gray-700 mb-1 ml-1">宠物名称</label>
              <div class="relative">
                <input 
                  type="text" 
                  id="petName" 
                  v-model="bindForm.petName"
                  class="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 transition-all text-sm"
                  placeholder="给宠物起个名字吧" 
                  required
                >
                <img style="width: 15px;height: 15px;" class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/paw3.png"/>
                <!-- <font-awesome-icon icon="paw" class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" /> -->
              </div>
            </div>

            <!-- 宠物类型 -->
            <div class="relative">
              <label for="petBreed" class="block text-xs font-medium text-gray-700 mb-1 ml-1">宠物类型</label>
              <select 
                id="petBreed" 
                v-model="bindForm.varietyType"
                class="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 transition-all appearance-none text-sm" 
                required
              >
                <option value="">选择宠物类型</option>
                <option value="1">狗</option>
                <option value="2">猫</option>
              </select>
              <!-- <div class="absolute right-3 top-[60%] -translate-y-1/2 pointer-events-none">
                <font-awesome-icon icon="chevron-down" class="text-gray-400 text-xs" />
              </div> -->
            </div>

            <!-- 宠物品种 -->
            <div class="relative">
              <label for="petBreed" class="block text-xs font-medium text-gray-700 mb-1 ml-1">宠物品种</label>
              <select 
                id="petBreed" 
                v-model="bindForm.varietyId"
                class="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 transition-all appearance-none text-sm" 
                required
              >
                <option value="">选择宠物品种</option>
                <option v-for="item in petList" :key="item.varietyId" :value="item.varietyId">{{ item.variety }}</option>
              </select>
              <!-- <div class="absolute right-3 top-[60%] -translate-y-1/2 pointer-events-none">
                <font-awesome-icon icon="chevron-down" class="text-gray-400 text-xs" />
              </div> -->
            </div>

            <!-- 年龄和体重 -->
            <div class="grid grid-cols-2 gap-3">
              <div class="relative">
                <label for="petAge" class="block text-xs font-medium text-gray-700 mb-1 ml-1">
                  宠物年龄 <span class="text-gray-400 text-[10px]">(1-99岁)</span>
                </label>
                <div class="relative">
                  <input 
                    type="number" 
                    id="petAge" 
                    v-model="bindForm.age"
                    @input="onAgeInput"
                    class="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 transition-all pr-8 text-sm"
                    min="1" 
                    max="99"
                    step="1"
                    placeholder="年龄" 
                    required
                  >
                  <span class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-xs">岁</span>
                </div>
              </div>

              <div class="relative">
                <label for="petWeight" class="block text-xs font-medium text-gray-700 mb-1 ml-1">
                  宠物体重 <span class="text-gray-400 text-[10px]">(≤200kg)</span>
                </label>
                <div class="relative">
                  <input 
                    type="number" 
                    id="petWeight" 
                    v-model="bindForm.weightKg"
                    class="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 transition-all pr-8 text-sm"
                    min="0.1" 
                    max="200"
                    step="0.1"
                    placeholder="体重" 
                    required
                    @input="onWeightInput"
                  >
                  <span class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 text-xs">kg</span>
                </div>
                <p class="text-xs text-red-500 mt-1" v-if="weightError">请输入1<=200之间的数字（最多1位小数）</p>
              </div>
            </div>
          </div>

          <!-- 分隔线 -->
          <div class="border-t border-gray-100 my-2"></div>

          <!-- 设备信息 -->
          <div class="space-y-3">
            <div class="relative">
              <label for="deviceCode" class="block text-xs font-medium text-gray-700 mb-1 ml-1">设备编码</label>
              <div class="flex space-x-2">
                <div class="relative flex-1">
                  <input 
                    type="text" 
                    id="deviceCode" 
                    v-model="bindForm.deviceName"
                    class="w-full px-3 py-2.5 bg-gray-50 border border-gray-200 rounded-lg text-gray-700 focus:outline-none focus:ring-2 focus:ring-blue-100 focus:border-blue-300 transition-all text-sm"
                    placeholder="输入或扫描设备编码" 
                    required
                  >
                  <img style="width: 15px;height: 15px;" class="absolute right-3 top-1/3 -translate-y-1/2 text-gray-400" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/device.png"/>
                  <!-- <font-awesome-icon icon="microchip" class="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400" /> -->
                </div>
                <button 
                  type="button"
                  class="bg-blue-500 hover:bg-blue-600 text-white rounded-lg w-10 flex items-center justify-center transition-colors shadow-sm hover:shadow"
                  @click="scanQRCode"
                >
                  <img style="width: 16px;height: 16px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/qrcode.png"/>
                  <!-- <font-awesome-icon icon="qrcode" /> -->
                </button>
              </div>
            </div>

            <!-- 扫码区域 -->
            <div v-if="showScanner" class="space-y-3 animate-fadeIn">
              <div class="bg-gray-50 rounded-lg overflow-hidden border border-gray-200">
                <div id="reader" ref="qrScanner" class="h-56"></div>
              </div>
              <button 
                type="button"
                class="w-full px-3 py-2 bg-gray-100 hover:bg-gray-200 text-gray-600 rounded-lg font-medium transition-colors text-sm flex items-center justify-center gap-2"
                @click="closeScanner"
              >
                <font-awesome-icon icon="times-circle" />
                <span>关闭扫码</span>
              </button>
            </div>
          </div>

          <!-- 提交按钮 -->
          <button 
            type="submit"
            class="w-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-lg px-4 py-2.5 font-medium transition-all duration-300 hover:shadow-lg mt-2 flex items-center justify-center gap-2"
          >
            <!-- <font-awesome-icon icon="check-circle" /> -->
            <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/check-circle.png"/>
            <span>确认添加</span>
          </button>
        </form>
      </div>
    </div>

    <!-- 设备详情模态框 -->
    <div id="deviceDetailModal" class="fixed inset-0 z-50" :class="{'hidden': !showDeviceDetailDialog}">
      <div class="modal-backdrop absolute inset-0 bg-black/40" @click="closeDeviceDetailModal"></div>
      <div class="modal-content absolute top-1/2 left-1/2 w-11/12 max-w-md bg-white rounded-2xl p-6 shadow-xl">
        <div class="flex justify-between items-center mb-6">
          <h3 class="text-xl font-semibold text-gray-800">设备详情</h3>
          <button @click="closeDeviceDetailModal" class="text-gray-400 hover:text-gray-600 transition-colors">
            <!-- <font-awesome-icon icon="times" class="text-xl" /> -->
            <img style="width: 25px;height: 25px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/times.png"/>
          </button>
        </div>

        <div class="space-y-6" v-if="selectedDevice">
          <!-- 基本信息 -->
          <div class="space-y-4">
            <div class="flex items-center space-x-4">
              <div class="w-16 h-16 bg-gradient-to-br from-blue-400 to-blue-500 rounded-xl flex items-center justify-center">
                <!-- <font-awesome-icon icon="paw" class="text-white text-2xl" /> -->
                <img v-if="selectedDevice.petImage" :src="selectedDevice.petImage" alt="" class="w-16 h-16 rounded-xl">
                <!-- <font-awesome-icon v-else icon="paw" class="text-white text-2xl" /> -->
              </div>
              <div>
                <h4 class="text-lg font-medium text-gray-800">{{ selectedDevice.petName }}</h4>
                <p class="text-sm text-gray-500">设备ID: {{ selectedDevice.deviceName }}</p>
              </div>
            </div>
          </div>

          <!-- 设备状态 -->
          <div class="grid grid-cols-3 gap-4 text-center">
            <div class="bg-gray-50 rounded-xl p-3">
              <p class="text-gray-500 text-sm mb-1">电量</p>
              <p :class="getBatteryClass(selectedDevice.machinePower)" class="font-medium">{{ selectedDevice.machinePower }}%</p>
            </div>
            <div class="bg-gray-50 rounded-xl p-3">
              <p class="text-gray-500 text-sm mb-1">信号</p>
              <p :class="selectedDevice.machineStatus === 'online' ? 'text-blue-500' : 'text-gray-500'" class="font-medium">
                {{ selectedDevice.machineStatus === 'online' ? '良好' : '--' }}
              </p>
            </div>
            <div class="bg-gray-50 rounded-xl p-3">
              <p class="text-gray-500 text-sm mb-1">固件版本</p>
              <p class="font-medium text-gray-700">{{ selectedDevice.firmwareVersion || 'v2.1.0' }}</p>
            </div>
          </div>

          <!-- 默认设备设置 -->
          <div class="space-y-3">
            <div class="flex items-center justify-between bg-gray-50 rounded-xl p-4 transition-all hover:bg-gray-100">
              <div class="flex items-center space-x-3">
                <div class="w-10 h-10 rounded-full bg-blue-100 flex items-center justify-center shadow-inner">
                  <!-- <font-awesome-icon icon="crown" class="text-blue-500 text-lg" /> -->
                  <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/crown2.png"/>
                </div>
                <div>
                  <h4 class="font-medium text-gray-700 text-base">默认设备</h4>
                  <p class="text-xs text-gray-500 mt-0.5">设为默认后，首页将显示该设备的宠物信息</p>
                </div>
              </div>
              <div class="custom-switch-wrapper">
                <div 
                  :class="['custom-switch',{ 
                    'custom-switch-active': selectedDevice.isDefault === 1,
                    'custom-switch-disabled': selectedDevice.isDefault === 1 // 这里加禁用class
                  }]" 
                  @click="setAsDefault"
                >
                  <div class="custom-switch-circle">
                    <span v-if="selectedDevice.isDefault === 1" class="check-icon">✓</span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 分隔线 -->
          <div class="border-t border-gray-100 my-6"></div>

          <!-- 固件更新按钮 -->
          <div class="space-y-3">
            <button 
              class="update-btn w-full text-white rounded-xl p-3.5 flex items-center justify-center space-x-2 shadow-sm hover:shadow-md"
              @click="updateFirmware"
              :disabled="updating"
            >
              <img v-if="updating" class="loadingAni" style="width: 15px;height: 15px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/spinner.png"/>
              <!-- <font-awesome-icon :icon="updating ? 'spinner' : 'arrow-up-from-bracket'" :spin="updating" class="mr-2" /> -->
              <span class="font-medium">{{ updating ? '检查中...' : '检查固件更新' }}</span>
            </button>
          </div>

          <!-- 分隔线 -->
          <div class="border-t border-gray-100 my-6"></div>

          <!-- 解除设备绑定按钮 -->
          <div class="space-y-3">
            <button 
              class="w-full py-3 px-4 bg-red-50 hover:bg-red-100 text-red-500 rounded-xl flex items-center justify-center space-x-2 transition-all duration-300 border border-red-100"
              @click="showUnbindConfirm"
            >
              <img style="width: 18px;height: 18px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/unlink.png"/>
              <!-- <font-awesome-icon icon="unlink" class="mr-2" /> -->
              <span class="font-medium">解除设备绑定</span>
            </button>
          </div>
        </div>
      </div>
      
      <!-- 解除绑定确认模态框 - 嵌套在设备详情模态框内 -->
      <div v-if="showUnbindConfirmDialog" class="fixed inset-0 z-[60]">
        <div class="modal-backdrop absolute inset-0 bg-black/60" @click="closeUnbindConfirm"></div>
        <div class="modal-content absolute bottom-0 left-0 right-0 bg-white rounded-t-2xl p-5 shadow-xl animate-slideUp w-full">
          <div class="w-12 h-1 bg-gray-200 rounded-full mx-auto mb-4"></div>
          
          <div class="text-center mb-6">
            <div class="w-16 h-16 bg-red-100 rounded-full mx-auto flex items-center justify-center mb-4">
              <!-- <font-awesome-icon icon="exclamation-triangle" class="text-red-500 text-2xl" /> -->
              <img style="width: 23px;height: 23px;" class="text-red-500 text-2xl" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/exclamation-triangle.png"/>
            </div>
            <h3 class="text-lg font-semibold text-gray-800">确认解除绑定</h3>
            <p class="text-gray-500 text-sm mt-2">
              解除绑定后，该设备将从您的账户中移除。<br>
              您确定要继续吗？
            </p>
          </div>
          
          <div class="space-y-3">
            <button 
              class="w-full py-3 px-4 bg-red-500 hover:bg-red-600 text-white rounded-xl font-medium transition-colors flex items-center justify-center"
              @click="unbindDevice"
              :disabled="unbinding"
            >
              <img v-if="unbinding" class="loadingAni" style="width: 15px;height: 15px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/spinner.png"/>
              <!-- <font-awesome-icon v-if="unbinding" icon="spinner" spin class="mr-2" /> -->
              <span>{{ unbinding ? '解除中...' : '确认解除绑定' }}</span>
            </button>
            
            <button 
              class="w-full py-3 px-4 bg-gray-100 hover:bg-gray-200 text-gray-700 rounded-xl font-medium transition-colors"
              @click="closeUnbindConfirm"
            >
              取消
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- QR扫描模态框 -->
    <div v-if="showScanQR" class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
      <div class="bg-white w-11/12 max-w-md rounded-2xl p-6">
        <div class="flex justify-between items-center mb-6">
          <h3 class="text-lg font-semibold text-gray-800">扫描设备二维码</h3>
          <button @click="closeScanner" class="text-gray-500 hover:text-gray-700">
            <!-- <font-awesome-icon icon="times" /> -->
            <img style="width: 20px;height: 20px;" src="https://airpets-image.oss-cn-chengdu.aliyuncs.com/icon/times.png"/>
          </button>
        </div>
        <div class="mb-4">
          <p class="text-sm text-gray-600 mb-4">请将设备上的二维码对准扫描框</p>
          <div id="reader" class="w-full h-64 border border-gray-300 rounded-lg"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatDate } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import { Html5Qrcode } from "html5-qrcode"
import { RPC } from '@/api/rpc'
export default {
  name: 'DeviceList',
  data() {
    return {
      bindForm: {
        varietyType: '1',
      },
      weightError: '',
      refreshing: false,
      showBindDialog: false,
      showDeviceDetailDialog: false,
      showUnbindConfirmDialog: false,
      showScanner: false,
      showScanQR: false,
      devices: [],
      selectedDevice: null,
      updating: false,
      unbinding: false,
      html5QrcodeScanner: null,
      userId: null,
      petList: []
    }
  },
  computed: {
    ...mapGetters(['currentDevice'])
  },
  created() {
    this.userId = sessionStorage.getItem('info')?JSON.parse(sessionStorage.getItem('info')).userId : null
    // 初始化设备数据
    this.loadDevices();
    this.getPetList()
  },
  beforeDestroy() {
    // 清理HTML5 QR扫描器
    if (this.html5QrcodeScanner) {
      if (typeof this.html5QrcodeScanner.clear === 'function') {
        this.html5QrcodeScanner.clear();
      } else if (typeof this.html5QrcodeScanner.stop === 'function') {
        this.html5QrcodeScanner.stop().catch(error => console.error(error));
      }
      this.html5QrcodeScanner = null;
    }
  },
  methods: {
    ...mapActions(['updateDevices', 'selectDevice']),
    formatDate,
    onAgeInput(e) {
      let val = e.target.value;
      // 只保留数字
      val = val.replace(/\D/g, '');
      // 转为数字并限制范围
      let num = Number(val);
      if (num < 1) num = 1;
      if (num > 99) num = 99;
      this.bindForm.age = num ? num : '';
    },
    onWeightInput(e) {
      let val = e.target.value;
      // 只允许数字和小数点
      val = val.replace(/[^0-9.]/g, '');
      // 最多1位小数
      if (val.indexOf('.') !== -1) {
        val = val.replace(/^(\d+)\.(\d).*$/, '$1.$2');
      }
      // 转为数字
      let num = Number(val);
      // 校验范围
      if (val === '' || isNaN(num)) {
        this.weightError = '请输入1<=200之间的数字（最多1位小数）';
      } else if (num < 1 || num > 200) {
        this.weightError = '请输入1<=200之间的数字（最多1位小数）';
      } else {
        this.weightError = '';
      }
      this.bindForm.weightKg = val;
    },
    getPetList() {
      RPC.getPetList({
        "pageIndex": 1,
        "pageSize": 100,
        "variety": "",
        "varietyType": this.bindForm.varietyType
      }).then(res=>{
        this.petList = res.list
      })
    },
    // 加载设备数据
    loadDevices() {
      // 使用模拟数据
      let data = {
        "pageIndex": 1,
        "pageSize": 100,
        "userId": this.userId
      }
      RPC.deviceList(data).then(res=>{
        if (res.list) {
          this.devices = res.list  
        }
      })
    },
    getBatteryClass(percentage) {
      if (percentage <= 20) return 'text-red-500'
      if (percentage <= 50) return 'text-yellow-500'
      return 'text-green-500'
    },
    showAddDeviceModal() {
      this.showBindDialog = true
    },
    closeAddDeviceModal() {
      this.showBindDialog = false
      this.bindForm = {
        varietyType: '1',
      }
      this.showScanner = false
      
      if (this.html5QrcodeScanner) {
        if (typeof this.html5QrcodeScanner.clear === 'function') {
          this.html5QrcodeScanner.clear();
        } else if (typeof this.html5QrcodeScanner.stop === 'function') {
          this.html5QrcodeScanner.stop().catch(error => console.error(error));
        }
        this.html5QrcodeScanner = null;
      }
    },
    scanQRCode() {
      this.showScanQR = true;
      
      // 确保DOM元素已经渲染
      this.$nextTick(() => {
        // 检查HTML元素是否存在
        const readerElement = document.getElementById('reader');
        if (!readerElement) {
          console.error('HTML Element with id=reader not found');
          this.showScanQR = false;
          this.$toast?.fail?.('无法初始化扫描器，请重试');
          return;
        }
        
        try {
          // 如果已经存在扫描实例，先清理它
          if (this.html5QrcodeScanner) {
            this.html5QrcodeScanner.stop().catch(error => console.error(error));
            this.html5QrcodeScanner = null;
          }
          
          const html5QrCode = new Html5Qrcode("reader");
          this.html5QrcodeScanner = html5QrCode;
          
          const config = { fps: 10, qrbox: { width: 250, height: 250 } };
          
          html5QrCode.start(
            { facingMode: "environment" },
            config,
            (decodedText) => {
              console.log(`扫描结果: ${decodedText}`);
              this.bindForm.deviceName = decodedText;
              html5QrCode.stop().catch(error => console.error(error));
              this.showScanQR = false;
            },
            (errorMessage) => {
              // 忽略扫描错误
              console.log(errorMessage);
            }
          ).catch((err) => {
            console.error(`无法启动扫描: ${err}`);
            this.$toast?.fail?.('无法启动扫描，请检查相机权限');
          });
        } catch (error) {
          console.error('扫描器初始化失败:', error);
          this.$toast?.fail?.('扫描器初始化失败');
          this.showScanQR = false;
        }
      });
    },
    closeScanner() {
      this.showScanQR = false;
      // 如果扫描器实例存在，停止扫描
      if (this.html5QrcodeScanner) {
        this.html5QrcodeScanner.stop().catch(error => console.error(error));
        this.html5QrcodeScanner = null;
      }
    },
    async bindDevice() {
      if (!this.bindForm.deviceName) {
        this.$toast?.fail?.('请填写完整信息')
        return
      }
      this.petList.map(item=>{
        if (item.varietyId == this.bindForm.varietyId) {
          this.bindForm.variety = item.variety
        }
      })
      console.log(this.bindForm)
      RPC.machineBind(this.bindForm).then(res=>{
        console.log(res)
        this.closeAddDeviceModal()
        this.$toast?.success?.('添加设备成功')
        this.loadDevices()
      })
      return
      
      
      // 添加模拟设备
      const newDevice = {
        id: this.bindForm.deviceName || `PET${Date.now().toString().substr(-4)}`,
        name: this.deviceName,
        type: '智能项圈 Mini',
        status: 'online',
        battery: 100,
        signal: 99,
        firmwareVersion: 'v2.1.0',
        lastUpdate: Date.now()
      }
      
      this.devices.push(newDevice)
      this.closeAddDeviceModal()
      this.$toast?.success?.('添加设备成功')
    },
    showDeviceDetail(device) {
      this.selectedDevice = device
      this.showDeviceDetailDialog = true
    },
    closeDeviceDetailModal() {
      this.showDeviceDetailDialog = false
      this.selectedDevice = null
    },
    setAsDefault(event) {
      // 添加波纹效果
        console.log(this.selectedDevice)
      const switchEl = event.currentTarget.querySelector('.custom-switch');
      if (switchEl) {
        const ripple = document.createElement('span');
        ripple.classList.add('ripple-effect');
        switchEl.appendChild(ripple);
        
        // 在动画结束后移除波纹元素
        ripple.addEventListener('animationend', () => {
          ripple.remove();
        });
      }
      RPC.machineDefault({machineId:this.selectedDevice.machineId}).then(res=>{
        sessionStorage.setItem('deviceCode',res.data.machineId)
        this.selectedDevice.isDefault = this.selectedDevice.isDefault == 1 ? 0 : 1
        this.$toast?.('设置成功')
        this.loadDevices()
        this.closeDeviceDetailModal()
      })
      // // 更新默认设备
      // this.selectDevice(event.currentTarget.dataset.deviceId === this.currentDevice?.id ? null : event.currentTarget.dataset.deviceId);
      
      // // 显示提示
      // this.$toast?.success?.({
      //   message: event.currentTarget.dataset.deviceId === this.currentDevice?.id ? '已取消默认设备' : `已将${event.currentTarget.dataset.deviceId}设备设为默认设备`,
      //   position: 'bottom'
      // });
    },
    updateFirmware() {
      this.updating = true
      setTimeout(() => {
        this.$toast?.('当前已是最新版本')
        this.updating = false
      }, 1500)
    },
    // 显示解除绑定确认框
    showUnbindConfirm() {
      this.showUnbindConfirmDialog = true;
    },
    
    // 关闭解除绑定确认框
    closeUnbindConfirm() {
      this.showUnbindConfirmDialog = false;
    },
    
    // 解除设备绑定
    unbindDevice() {
      if (!this.selectedDevice) return;
      
      this.unbinding = true;
      console.log(this.selectedDevice)
      
      
      RPC.machineUnBind({machineId:this.selectedDevice.machineId}).then(res=>{
        console.log(res)
         // 关闭所有相关对话框
        this.closeUnbindConfirm();
        this.closeDeviceDetailModal();
        
        // 显示成功提示
        this.$toast?.success?.('设备已成功解除绑定');
        
        this.unbinding = false;
        this.loadDevices()
      })
    }
  }
}
</script>

<style scoped>
:root {
  --primary-color: #3B82F6;
  --secondary-color: #93C5FD;
  --accent-color: #2563EB;
  --background-color: #F3F4F6;
}

body {
  background-color: var(--background-color);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.device-card {
  transition: all 0.3s ease;
}

.device-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.1);
}

.device-card:hover .default-badge {
  background: linear-gradient(to right, #3b82f6, #2563eb);
}

/* 默认设备标识动画 */
.default-badge {
  transition: all 0.3s ease;
}

.default-badge i {
  display: inline-block;
  transform-origin: center;
  animation: gentleFloat 2s ease-in-out infinite;
}

@keyframes gentleFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-2px);
  }
}

/* 默认设备开关的波纹效果 */
.ripple-effect {
  position: absolute;
  border-radius: 50%;
  background-color: rgba(59, 130, 246, 0.3);
  width: 100%;
  height: 100%;
  transform: scale(0);
  animation: ripple 0.6s ease-out;
}

@keyframes ripple {
  to {
    transform: scale(2.5);
    opacity: 0;
  }
}

/* 默认设备标识出现动画 */
.animate-badge {
  animation: badgeAppear 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes badgeAppear {
  from {
    transform: scale(0);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* 默认设备开关样式增强 */
input:checked + div:after {
  content: '✓';
  display: flex;
  align-items: center;
  justify-content: center;
  color: #3B82F6;
  font-size: 0.75rem;
  font-weight: bold;
}

/* 设备卡片悬停效果增强 */
.device-card:hover .default-badge > div {
  background-color: #EFF6FF;
  border-color: #BFDBFE;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(59, 130, 246, 0.1), 0 2px 4px -1px rgba(59, 130, 246, 0.06);
}

/* 固件更新按钮样式 */
.update-btn {
  background-image: linear-gradient(to right, #3b82f6, #2563eb);
  transition: all 0.3s ease;
}

.update-btn:hover {
  background-image: linear-gradient(to right, #2563eb, #1d4ed8);
  transform: translateY(-1px);
}

.update-btn:active {
  transform: translateY(0);
}

.modal-content {
  transform: translate(-50%, -50%);
}

.modal-backdrop {
  backdrop-filter: blur(8px);
}

/* 模型选择器样式 */
.models-container {
  position: relative;
  padding: 0.5rem 0;
  margin: 0 -1.5rem;
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  overflow: hidden;
}

.models-container::before,
.models-container::after {
  content: '';
  position: absolute;
  top: 0;
  bottom: 0;
  width: 2.5rem;
  z-index: 1;
  pointer-events: none;
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.models-container::before {
  left: 0;
  background: linear-gradient(to right, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0));
}

.models-container::after {
  right: 0;
  background: linear-gradient(to left, rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0));
}

/* 当滚动到边缘时淡化渐变效果，提示用户可以继续滑动 */
.models-container.at-start::before {
  opacity: 0.3;
}

.models-container.at-end::after {
  opacity: 0.3;
}

.models-wrapper {
  width: 100%;
  touch-action: pan-x;
  overflow-x: auto;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  display: flex;
  padding: 0 1.5rem;
  cursor: grab;
  -webkit-overflow-scrolling: touch;
  /* 增强横向滑动效果 */
  transform: translateZ(0);
  will-change: transform, scroll-position;
  /* 修改滚动边界行为，减少边缘回弹 */
  overscroll-behavior-x: none;
  /* 移除滚动吸附行为 */
  scroll-snap-type: none;
  scroll-behavior: auto;
}

.models-wrapper.active {
  cursor: grabbing;
  will-change: transform, scroll-position;
}

.models-wrapper::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.model-select-btn {
  transition: all 0.2s ease;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
  margin-right: 0.75rem;
  transform: translateZ(0);
  will-change: transform, opacity;
  /* 移除滚动吸附 */
  scroll-snap-align: none;
  /* 增强3D效果 */
  transform-style: preserve-3d;
  perspective: 1000px;
  -webkit-transform: translate3d(0, 0, 0);
  -webkit-backface-visibility: hidden;
  -webkit-perspective: 1000;
  /* 添加硬件加速 */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* 优化阴影渲染 */
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.05));
}

.model-select-btn:hover {
  transform: translateY(-2px) scale(1.02);
  filter: drop-shadow(0 4px 8px rgba(59, 130, 246, 0.15));
}

/* 选中标记样式 - 保持永久显示，无动画 */
.model-selected {
  background: linear-gradient(135deg, #EFF6FF 0%, #DBEAFE 100%) !important;
  border: 2px solid #3B82F6;
  transform: translateY(-3px) scale(1.05);
  box-shadow: 0 10px 25px -3px rgba(59, 130, 246, 0.4), 0 4px 12px -2px rgba(59, 130, 246, 0.3);
  z-index: 10;
  position: relative;
}

/* 添加持久的发光效果 - 不使用动画 */
.model-selected::after {
  content: '';
  position: absolute;
  inset: -4px;
  border-radius: inherit;
  background: transparent;
  border: 2px solid transparent;
  box-shadow: 0 0 15px 2px rgba(59, 130, 246, 0.6);
  z-index: -1;
}

.model-selected::before {
  content: '';
  position: absolute;
  inset: -2px;
  background: radial-gradient(circle at center, rgba(59, 130, 246, 0.2), transparent 70%);
  border-radius: inherit;
  z-index: -1;
  box-shadow: 0 0 10px 3px rgba(59, 130, 246, 0.4);
}

/* 模型图片样式 */
.model-select-btn img {
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), filter 0.3s ease;
  backface-visibility: hidden;
  transform: translateZ(0);
  will-change: transform, filter;
}

.model-select-btn:hover img {
  filter: brightness(1.05);
  transform: scale(1.05);
}

.model-selected img {
  filter: brightness(1.1) contrast(1.05);
  transform: scale(1.05);
}

/* 选中标记样式 - 永久显示无动画 */
.model-selected .absolute.top-1.right-1 {
  opacity: 1;
  transform: scale(1);
}

/* 移除选中标记的动画 */
.check-badge {
  opacity: 1;
  transform: scale(1);
}

@keyframes checkmarkAppear {
  from {
    transform: scale(1);
    opacity: 1;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}

/* 优化滑动指示器 */
.models-container .scroll-indicator {
  position: absolute;
  bottom: -0.5rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0.25rem;
  z-index: 2;
  /* 添加过渡效果 */
  transition: opacity 0.3s ease;
}

.models-container .scroll-indicator span {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #CBD5E1;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1); /* 弹性过渡 */
}

.models-container .scroll-indicator span.active {
  background-color: #3B82F6;
  transform: scale(1.5);
  box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1);
}

/* 左右滑动箭头样式 */
.models-container button {
  opacity: 0.7;
  transition: all 0.2s ease;
  transform: translateZ(0);
}

.models-container button:hover {
  opacity: 1;
  transform: translateY(-50%) scale(1.1);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.models-container button:active {
  transform: translateY(-50%) scale(0.95);
}

/* 添加滑动指示器 */
.models-container .scroll-indicator {
  position: absolute;
  bottom: -0.5rem;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0.25rem;
  z-index: 2;
}

.models-container .scroll-indicator span {
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background-color: #CBD5E1;
  transition: all 0.3s ease;
}

.models-container .scroll-indicator span.active {
  background-color: #3B82F6;
  transform: scale(1.25);
}

/* 滑动动画 */
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.model-select-btn {
  animation: slideIn 0.3s ease-out forwards;
  animation-delay: calc(0.05s * var(--index, 0));
  opacity: 0;
}

/* 横向滑动特效 */
@keyframes horizontalBounce {
  0%, 100% {
    transform: translateX(0);
  }
  50% {
    transform: translateX(-5px);
  }
}

.models-container:hover button:first-of-type {
  animation: horizontalBounce 1s ease-in-out 2;
}

.models-wrapper {
  position: relative;
  transition: transform 0.3s ease;
}

.models-wrapper::after {
  content: '';
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 60px;
  background: linear-gradient(to left, rgba(255, 255, 255, 0.8), rgba(255, 255, 255, 0));
  pointer-events: none;
  opacity: 0.6;
}

/* 3D卡片效果 */
.model-select-btn {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.model-select-btn:hover {
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  transform: translateY(-5px) rotateY(5deg);
}

.model-select-btn:nth-child(even):hover {
  transform: translateY(-5px) rotateY(-5deg);
}

#reader {
  width: 100%;
  height: 300px;
}

select {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24' stroke='%236B7280'%3E%3Cpath stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M19 9l-7 7-7-7'%3E%3C/path%3E%3C/svg%3E");
  background-position: right 1rem center;
  background-repeat: no-repeat;
  background-size: 1.5em 1.5em;
  padding-right: 2.5rem;
}

.toggle-switch {
  width: 3.5rem;
  height: 2rem;
  background-color: #D1D5DB;
  border-radius: 9999px;
  position: relative;
  transition: background-color 0.3s;
  cursor: pointer;
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
  overflow: visible;
}

.toggle-switch::after {
  content: '';
  position: absolute;
  top: 0.25rem;
  left: 0.25rem;
  width: 1.5rem;
  height: 1.5rem;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.3s, background-color 0.3s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  font-weight: bold;
  color: transparent;
}

.toggle-switch.active {
  background-color: #3B82F6;
}

.toggle-switch.active::after {
  /* 确保不会超出边界 */
  transform: translateX(calc(3.5rem - 1.5rem - 0.5rem));
  color: #3B82F6;
  content: '✓';
}

/* 自定义开关样式 */
.custom-switch-wrapper {
  padding: 2px;
}

.custom-switch {
  position: relative;
  width: 56px;
  height: 30px;
  background-color: #D1D5DB;
  border-radius: 30px;
  cursor: pointer;
  transition: background-color 0.3s;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.1);
}

.custom-switch-active {
  background-color: #3B82F6;
}

.custom-switch-circle {
  position: absolute;
  top: 3px;
  left: 3px;
  width: 24px;
  height: 24px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.3s;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
}

.custom-switch-active .custom-switch-circle {
  transform: translateX(26px);
}

.check-icon {
  color: #3B82F6;
  font-size: 14px;
  font-weight: bold;
}

/* 模型选择波纹效果 */
.model-ripple {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  width: 120%;
  height: 120%;
  background-color: rgba(59, 130, 246, 0.3);
  border-radius: inherit;
  z-index: 0;
  animation: modelRipple 0.6s ease-out forwards;
}

@keyframes modelRipple {
  to {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 0;
  }
}

/* 模型选中过渡动画 */
.model-selecting {
  animation: modelSelecting 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes modelSelecting {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}

/* 添加新设备模态框动画 */
@keyframes modalFade {
  from {
    opacity: 0;
    transform: translate(-50%, -48%) scale(0.96);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.animate-modalFade {
  animation: modalFade 0.3s ease-out forwards;
}

.animate-fadeIn {
  animation: fadeIn 0.3s ease-out forwards;
}

/* 输入框焦点效果增强 */
input:focus, select:focus {
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

/* 美化滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: #CBD5E1;
  border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
  background: #94A3B8;
}

/* 美化数字输入框的上下箭头 */
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  opacity: 0.3;
  height: 20px;
}

/* 添加设备表单项悬停效果 */
#addDeviceForm .relative:hover label {
  color: #3B82F6;
}

/* 表单输入框动画效果 */
#addDeviceForm input, #addDeviceForm select {
  transition: all 0.2s ease;
}

#addDeviceForm input:focus, #addDeviceForm select:focus {
  transform: translateY(-1px);
}

/* 模态框内容区域滚动优化 */
.modal-content {
  max-height: 90vh;
  overflow-y: auto;
  overscroll-behavior: contain;
}

/* 添加从底部滑入的动画 */
@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.animate-slideUp {
  animation: slideUp 0.3s ease-out forwards;
}

/* 添加从顶部滑入的动画 */
@keyframes slideDown {
  from {
    transform: translateY(-100%);
  }
  to {
    transform: translateY(0);
  }
}

.animate-slideDown {
  animation: slideDown 0.3s ease-out forwards;
}

/* 添加淡入动画 */
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.animate-fadeIn {
  animation: fadeIn 0.3s ease-out forwards;
}

.custom-switch-disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
.loadingAni {
  animation: rotate 2s linear infinite; /* 2秒一圈，无限循环 */
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style> 